// extracted by mini-css-extract-plugin
module.exports = {"topBox":"style_topBox__2vfYC","container":"style_container__1G98T","headerBox":"style_headerBox__q2WJy"};